export enum MeterTileTexts {
    TITLE = 'Zählerstand',
    LABEL_METER_ID = 'Zählernummer',
    LABEL_CONNECTED = 'verbunden',
    LABEL_DISCONNECTED = 'nicht verbunden',
    METER_VALUE_UNIT = 'kWh'
}
